<template>
  <div
    :class="{
      button__group: true,
      'button__group--vertical': vertical,
      'button__group--vertical-reverse': reverse,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ButtonGroup",
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/ButtonGroup.scss";
</style>
